import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from "../../../../Common";
import MaterialTable from "material-table";
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi, { x } from "@hapi/joi";
import { InjuryDetailsReportSchemaObject } from "../InjuryDetailsReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from "./createPdf";
import "../../../Common/Table/table.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import MessageModal from "../../../../UI/Modal/MessageModal";
import moment from "moment";

const screenCode = 'INJURYDETAILSREPORT';

export function InjuryDetailsReport(props) {
  const componentRef = useRef();
  const [divisions, setDivisions] = useState([]);
  const [groups, setGroups] = useState([]);
  const [estates, setEstates] = useState([]);
  const [injuryReportDetails, setInjuryReportDetails] = useState([]);
  const [multipleEstates, setMultipleEstates] = useState([]);
  const [isTableHide, setIsTableHide] = useState(true);
  const [divisionSummaryDetails, setDivisionSummaryDetails] = useState({
    groupID: "0",
    estateID: "0",
    divisionID: "0",
    searchDate: moment().format("YYYY-MM-DD"),
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: "0",
    estateID: "0",
    division: "0",
    searchDate: moment().format("YYYY-MM-DD"),
  });
  const [errors, setErrors] = useState({});
  const [permissionList, setPermissions] = useState({
    isAddEditEnabled: false,
    isGroupFilterEnabled: false,
    isOperationEntityFilterEnabled: false,
  });

  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "",
    disciption: "",
  });


  const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
  const schema = Joi.object(InjuryDetailsReportSchemaObject).options({
    allowUnknown: true,
  });

  useEffect(() => {
    trackPromise(
      getPermissions(),
      getGroupsForDropdown()
    );
  }, []);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWINJURYDETAILSREPORT');

    if (isAuthorized === undefined) {
      props.history.push('/unauthorized');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

    var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
    });

    var token = tokenService.getUserDetailsFromTokenV2();
    if (token.operationEntities.length > 0) {

      var estateArray = [];
      for (let item of Object.entries(token.operationEntities)) {
        estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
      }
      setMultipleEstates(estateArray)

      setDivisionSummaryDetails({
        ...divisionSummaryDetails,
        groupID: token.groupID,
      })

    }
    else {
      setDivisionSummaryDetails({
        ...divisionSummaryDetails,
        groupID: token.groupID,
        estateID: token.operationEntityID
      })
    }
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      groupID: token.groupID,
      estateID: token.operationEntityID
    });
    trackPromise(getGroupsForDropdown());
  }

  useEffect(() => {
    trackPromise(getEstatesForDropdown());
  }, [divisionSummaryDetails.groupID]);

  useEffect(() => {
    trackPromise(getDivisionsForDropDown());
  }, [divisionSummaryDetails.estateID]);

  function handleGroupChange(target) {
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      groupID: target.value,
      estateID: "0",
    });
    clearTable()
  }

  function handleEstateChange(target) {
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      estateID: target.value,
      searchDate: moment().format("YYYY-MM-DD"),
      divisionID: "0",
    });
    clearTable()
  }

  function handleDivisionChange(target) {
    setIsReportButtonsEnabled(false);
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      divisionID: target.value,
      searchDate: moment().format("YYYY-MM-DD"),
    });
    clearTable()
  }

  function handleSearchDateChange(target) {
    validateInputs(target);
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      searchDate: target.value,
    });
    clearTable()
  }

  function validateInputs(target) {
    const error = { ...errors };
    const errorMessage = validateProperty(
      target,
      InjuryDetailsReportSchemaObject
    );
    errorMessage
      ? (error[target.name] = errorMessage)
      : delete error[target.name];
    setErrors(error);
  }

  async function getGroupsForDropdown() {
    const result = await services.getAlGroupsForDropdown();
    setGroups(result);
  }

  async function getEstatesForDropdown() {
    const data = await services.getEstatesByGroupID(divisionSummaryDetails.groupID);
    setEstates(data);
  }

  async function getDivisionsForDropDown() {
    const data = await services.getDivisionByEstateID(divisionSummaryDetails.estateID);
    setDivisions(data);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupID: groups[searchForm.groupID],
      estateID: estates[searchForm.estateID],
      division: divisions[searchForm.divisionID],
      searchDate: searchForm.searchDate,
    });
  }
  //get injury report Details 
  async function GetInjuryDetailsReportData() {
    const response = await services.GetInjuryDetailsReportData(divisionSummaryDetails);
    if (response.statusCode == "Success") {
      getSelectedDropdownValuesForReport(divisionSummaryDetails);
      setInjuryReportDetails(response.data);
    } else {
      setMessageModel({
        ...messageModel,
        hidden: false,
        type: response.statusCode,
        disciption: response.message,
      });
      setTimeout(() => {
        modalDismissHandler();
      }, 3000);
    }
  }

  function onCancelClick() {
    clearState();
  }

  function clearState() {
    setDivisionSummaryDetails({
      ...divisionSummaryDetails,
      divisionID: "0",
      searchDate: moment().format("YYYY-MM-DD"),
    });
    setIsTableHide(true);
    setInjuryReportDetails([]);
    setErrors("");
    setIsReportButtonsEnabled(true);
  }

  function clearTable() {
    setIsTableHide(true);
    setInjuryReportDetails([]);
  }

  //generate excel file 
  const createFile = () => {
    if (!injuryReportDetails || injuryReportDetails.length === 0) {
      alert("No data available to export!");
      return;
    }

    const searchDetails = [
      ["Group:", selectedSearchValues.groupID || "-"],
      ["Estate:", selectedSearchValues.estateID || "-"],
      ["Division:", selectedSearchValues.division || "-"],
      ["Search Date:", selectedSearchValues.searchDate || "-"],
      []
    ];

    const searchWorksheet = XLSX.utils.aoa_to_sheet(searchDetails);

    const dataForExcel = injuryReportDetails.map((row) => ({
      "Reg No": row.employeeCode || "-",
      "Name": row.firstName || "-",
      "WorkTypeID": row.workTypeID === 1 ? "Sundry" : "Plucking",
      "Operator": row.operatorName || "-",
      "Injury Type": row.attackTypeName || "-",
      "Remark": row.remark || "-",
      "Approved By": row.approvedManagerName || "-",
      "Approved Date": row.approvedDate ? new Date(row.approvedDate).toLocaleDateString() : "-",
      "Reason": row.reason || "-",
      "Status": row.statusID === 1 ? "New" : row.statusID === 2 ? "Approved" : "Rejected",
    }));

    const tableWorksheet = XLSX.utils.json_to_sheet(dataForExcel, { origin: searchDetails.length });
    const worksheet = { ...searchWorksheet, ...tableWorksheet };

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Injury Report");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "Injury_Details_Report.xlsx");
  };


  return (
    <Fragment>
      <LoadingSpinerComponent />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <PageHeader
              title="Injury Details Report"
              isButtonEnable={permissionList.isAddEditEnabled}
            />
            <div className="card-body">
              <form onSubmit={{}} disabled={false}>
                <div className="form-group row">
                  <div className="col-md-4">
                    <InputLabel shrink id="groupID">
                      Group *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="groupID"
                      id="groupID"
                      name="groupID"
                      value={divisionSummaryDetails.groupID}
                      disabled={!permissionList.isGroupFilterEnabled}
                      onChange={(e) => handleGroupChange(e.target)}
                    >
                      <MenuItem value="0">--Select Group--</MenuItem>
                      {generateDropDownMenu(groups)}
                    </Select>
                    {errors["groupID"] && (
                      <FormHelperText error>{errors["groupID"]}</FormHelperText>
                    )}
                  </div>
                  <div className="col-md-4">
                    <InputLabel shrink id="estateID">
                      Operation Entity *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="estateID"
                      id="estateID"
                      name="estateID"
                      value={divisionSummaryDetails.estateID}
                      disabled={!permissionList.isOperationEntityFilterEnabled}
                      onChange={(e) => handleEstateChange(e.target)}
                    >
                      <MenuItem value="0">--Select Operation Entity--</MenuItem>
                      {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                    </Select>
                    {errors["estateID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["estateID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-4">
                    <InputLabel shrink id="">
                      Collection Point *
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="divisionID"
                      id="divisionID"
                      name="divisionID"
                      value={divisionSummaryDetails.divisionID}
                      onChange={(e) => handleDivisionChange(e.target)}
                    >
                      <MenuItem value="0">--Select Collection Point--</MenuItem>
                      {generateDropDownMenu(divisions)}
                    </Select>
                    {errors["divisionID"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["divisionID"]}
                      </FormHelperText>
                    )}
                  </div>
                  <div className="col-md-4">
                    <InputLabel shrink id="searchDate">
                      Search Date *
                    </InputLabel>
                    <TextField
                      fullWidth
                      id="searchDate"
                      name="searchDate"
                      type="date"
                      value={divisionSummaryDetails.searchDate}
                      onChange={(e) => handleSearchDateChange(e.target)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors["searchDate"] && (
                      <FormHelperText
                        id="errbranchCode"
                        className="text text-danger"
                      >
                        {errors["searchDate"]}
                      </FormHelperText>
                    )}
                  </div>
                </div>
                <div className="card-footer">
                  <input
                    disabled={validate(schema, divisionSummaryDetails) || isReportButtonsEnabled}
                    type="button"
                    className="btn btn-primary"
                    value="Search"
                    onClick={(e) => trackPromise(GetInjuryDetailsReportData())}
                  />

                  <input
                    type="button"
                    className="btn btn-warning pull-right"
                    value="Clear"
                    onClick={onCancelClick}
                  />
                </div>
              </form>

              <div>
                {injuryReportDetails.length > 0 && (
                  <MaterialTable
                    title="Multiple Actions Preview"
                    columns={[
                      { title: 'Reg No', field: 'employeeCode', render: rowData => rowData.employeeCode || '-' },
                      { title: 'Name', field: 'firstName', render: rowData => rowData.firstName || '-' },
                      { title: 'WorkTypeID', field: 'workTypeID', lookup: { 1: 'Sundry', 2: 'Plucking' } },
                      { title: 'Operator', field: 'operatorName', render: rowData => rowData.operatorName || '-' },
                      { title: 'Injury Type', field: 'attackTypeName', render: rowData => rowData.attackTypeName || '-' },
                      { title: 'Remark', field: 'remark', render: rowData => rowData.remark || '-' },
                      { title: 'ApprovedBy', field: 'approvedManagerName', render: rowData => rowData.approvedManagerName || '-' },
                      {
                        title: 'Approved Date',
                        field: 'approvedDate',
                        render: rowData => rowData.approvedDate
                          ? new Date(rowData.approvedDate).toLocaleDateString()
                          : '-'
                      },
                      { title: 'Reason', field: 'reason', render: rowData => rowData.reason || '-' },
                      {
                        title: 'Status', field: 'statusID', lookup: {
                          1: 'New',
                          2: 'Approved',
                          3: 'Rejected'
                        },
                      },
                    ]}
                    data={injuryReportDetails}
                    options={{
                      exportButton: false,
                      showTitle: false,
                      headerStyle: { textAlign: "left", height: '1%', paddingLeft: '1rem', paddingRight: '1rem', fontWeight: 'bold' },
                      cellStyle: { textAlign: "left", fontSize: '14px' },
                      columnResizable: false,
                      actionsColumnIndex: -1,
                    }}
                  />
                )}
              </div>
            </div>
            {injuryReportDetails.length != 0 ? (
              <div className="pt-2 mr-2" >
                <ReactToPrint
                  trigger={() => (
                    <input
                      type="button"
                      className="btn btn-primary pull-right ml-2 mr-3"
                      value="PDF"
                    />
                  )}
                  content={() => componentRef.current}
                  documentTitle="Injury Details Report"
                />
                <div hidden={true}>
                  <CreatePdf
                    ref={componentRef}
                    reportData={injuryReportDetails}
                    searchData={selectedSearchValues}
                  />
                </div>{" "}
                <input
                  type="button"
                  className="btn btn-primary pull-right ml-3"
                  value="Excel"
                  onClick={createFile}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
        clicked={modalDismissHandler}
      />
    </Fragment>
  );
}
